export const module3InitialState = {
  module3: {
    name: 'Expressions',
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      MoonFull: false,
      MoonCresent: false,
      Hawk: false,
      Owl: false,
      Tent: false,
      TentOld: false,
      Fire: false,
      Lantern: false,
      CactusBarell: false,
      CactusPrickly: false,
      CactusTall: false,
      CactusTall2: false,
      BootsCowboy: false,
      BootsHiking: false,
      Backpack: false,
      Canteen: false,
      Hat: false,
      Bandanna: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
      day9: false,
    },
  },
};

export const Module3Reducer = (state = module3InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE3_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        MoonFull: false,
        MoonCresent: false,
        Hawk: false,
        Owl: false,
        Tent: false,
        TentOld: false,
        Fire: false,
        Lantern: false,
        CactusBarell: false,
        CactusPrickly: false,
        CactusTall: false,
        CactusTall2: false,
        BootsCowboy: false,
        BootsHiking: false,
        Backpack: false,
        Canteen: false,
        Hat: false,
        Bandanna: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[]}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
        day9: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module3: {
          ...state.module3,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module3InitialState,
      };
    }
    case 'MODULE3_SET_DAY': {
      return {
        ...state,
        module3: {
          ...state.module3,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE3_SET_GameDetials': {
      return {
        ...state,
        module3: {
          ...state.module3,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE3_SET_stepCompleted': {
      return {
        ...state,
        module3: {
          ...state.module3,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE3_SET_dayCompleted': {
      return {
        ...state,
        module3: {
          ...state.module3,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE3_SET_CAMERAOPEN': {
      return {
        ...state,
        module3: {
          ...state.module3,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE3_SET_KEY': {
      return {
        ...state,
        module3: {
          ...state.module3,
          keys: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE3_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module3: {
          ...state.module3,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE3_SET_REWARD11': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            CactusTall: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD12': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            CactusTall2: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD21': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Tent: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD22': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            TentOld: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD31': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Hawk: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD32': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Owl: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD41': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            BootsHiking: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD42': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            BootsCowboy: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD51': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Lantern: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD52': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Fire: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD61': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            CactusPrickly: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD62': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            CactusBarell: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD71': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Canteen: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD72': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Backpack: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD81': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            MoonCresent: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD82': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            MoonFull: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_REWARD91': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Bandanna: action.payload,
          },
        },
      };
    }

    case 'MODULE3_SET_REWARD92': {
      return {
        ...state,
        module3: {
          ...state.module3,
          rewards: {
            ...state.module3.rewards,
            Hat: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }
    case 'MODULE3_SET_DAY_UNLOCK9': {
      return {
        ...state,
        module3: {
          ...state.module3,
          unlockedDays: {
            ...state.module3.unlockedDays,
            day9: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
export default Module3Reducer;
